import React, { createContext, useState, useEffect } from 'react';
import unitedstates from '../constants/states';
import canada from '../constants/provinces';
import australia from '../constants/australia';
import jpStates from '../constants/jp-states';
import mexico from '../constants/mx-states';
import brazil from '../constants/br-states';
import uae from '../constants/me-states';
import philippines from '../constants/ph-provinces';
import morocco from '../constants/morocco';
import tunisia from '../constants/tunisia';
import costaRica from '../constants/costa-rica';
import dominicanRepublic from '../constants/dominican-republic';
import guatemala from '../constants/guatemala';
import panama from '../constants/panama';
import puertoRico from '../constants/puerto-rico';
import india from '../constants/india';
import israel from '../constants/israel';
interface LocalizationContextType {
    locale: string;
    localeWith_: string;
    defaultCurrency: string;
    currencySign: string;
    stateDropdown: boolean;
    countryDropdown: boolean;
    postalCodeRequired: boolean;
    countryList: { ISO_CC: string; countryName: string }[];
    countryListPhysical?: { ISO_CC: string; countryName: string }[];
    countyField: boolean;
    states?: { code: string; name: string; en?: string }[];
    showTax: boolean;
}
interface LocalizationProviderProps {
    children: React.ReactNode;
}
type LocaleKey = keyof typeof Localization;


const Localization = Object.freeze({
    'en-us': {
        locale: "en-us",
        localeWith_: "en_US",
        defaultCurrency: "USD",
        currencySign: "$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "US", countryName: "United States" }
        ],
        states: unitedstates,
        showTax: true
    },
    'en-ca': {
        locale: "en-ca",
        localeWith_: "en_CA",
        defaultCurrency: "CAD",
        currencySign: "C$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "CA", countryName: "Canada" }
        ],
        states: canada,
        showTax: true
    },
    'ja-jp': {
        locale: "ja-jp",
        localeWith_: "ja_JP",
        defaultCurrency: "JPY",
        currencySign: "¥",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "JP", countryName: "日本" }
        ],
        states: jpStates,
        showTax: false
    },
    'en-gb': {
        locale: "en-gb",
        localeWith_: "en_GB",
        defaultCurrency: "GBP",
        currencySign: "£",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "GB", countryName: "United Kingdom" },
            { ISO_CC: "BM", countryName: "Bermuda" }
        ],
        states: [],
        showTax: true
    },
    'de-de': {
        locale: "de-de",
        localeWith_: "de_DE",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "DE", countryName: "Deutschland" },
            { ISO_CC: "LI", countryName: "Liechtenstein" },
        ],
        states: [],
        showTax: true
    },
    'fr-fr': {
        locale: "fr-fr",
        localeWith_: "fr_FR",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "FR", countryName: "France" }
        ],
        states: [],
        showTax: true
    },
    'es-es': {
        locale: "es-es",
        localeWith_: "es_ES",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "ES", countryName: "España" }
        ],
        states: [],
        showTax: true
    },
    'es-la': {
        locale: "es-la",
        localeWith_: "es_LA",
        defaultCurrency: "USD",
        currencySign: "$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "CR", countryName: "Costa Rica" },
            { ISO_CC: "DO", countryName: "Dominican Republic" },
            { ISO_CC: "GT", countryName: "Guatemala" },
            { ISO_CC: "PA", countryName: "Panama" },
            { ISO_CC: "PR", countryName: "Puerto Rico" },
        ],
        states: [],
        showTax: true
    },
    'it-it': {
        locale: "it-it",
        localeWith_: "it_IT",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "IT", countryName: "Italia" }
        ],
        states: [],
        showTax: true
    },
    'en-af': {
        locale: "en-af",
        localeWith_: "en_AF",
        defaultCurrency: "USD",
        currencySign: "$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "MA", countryName: "Morocco" },
            { ISO_CC: "TN", countryName: "Tunisia" },
        ],
        states: [],
        showTax: true
    },
    'en-eu': {
        locale: "en-eu",
        localeWith_: "en_EU",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "AT", countryName: "Austria" },
            { ISO_CC: "BE", countryName: "Belgium" },
            { ISO_CC: "BG", countryName: "Bulgaria" },
            { ISO_CC: "HR", countryName: "Croatia" },
            { ISO_CC: "CY", countryName: "Cyprus" },
            { ISO_CC: "CZ", countryName: "Czech Republic" },
            { ISO_CC: "DK", countryName: "Denmark" },
            { ISO_CC: "EE", countryName: "Estonia" },
            { ISO_CC: "FI", countryName: "Finland" },
            { ISO_CC: "FR", countryName: "France" },
            { ISO_CC: "DE", countryName: "Germany" },
            { ISO_CC: "GR", countryName: "Greece" },
            { ISO_CC: "HU", countryName: "Hungary" },
            { ISO_CC: "IS", countryName: "Iceland" },
            { ISO_CC: "IE", countryName: "Ireland" },
            { ISO_CC: "IT", countryName: "Italy" },
            { ISO_CC: "LV", countryName: "Latvia" },
            { ISO_CC: "LT", countryName: "Lithuania" },
            { ISO_CC: "LU", countryName: "Luxembourg" },
            { ISO_CC: "MT", countryName: "Malta" },
            { ISO_CC: "NL", countryName: "Netherlands" },
            { ISO_CC: "PL", countryName: "Poland" },
            { ISO_CC: "PT", countryName: "Portugal" },
            { ISO_CC: "RO", countryName: "Romania" },
            { ISO_CC: "SK", countryName: "Slovakia" },
            { ISO_CC: "SI", countryName: "Slovenia" },
            { ISO_CC: "ES", countryName: "Spain" },
            { ISO_CC: "SE", countryName: "Sweden" }
        ],
        countryListPhysical: [
            { ISO_CC: "BE", countryName: "Belgium" },
            { ISO_CC: "IE", countryName: "Ireland" },
            { ISO_CC: "LU", countryName: "Luxembourg" },
            { ISO_CC: "NL", countryName: "Netherlands" },
            { ISO_CC: "PT", countryName: "Portugal" }
        ],
        states: [],
        showTax: true
    },
    'en-au': {
        locale: "en-au",
        localeWith_: "en_AU",
        defaultCurrency: "AUD",
        currencySign: "AU$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "AU", countryName: "Australia" }
        ],
        states: australia,
        showTax: false
    },
    'en-sg': {
        locale: "en-sg",
        localeWith_: "en_SG",
        defaultCurrency: "SGD",
        currencySign: "S$",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "SG", countryName: "Singapore" }
        ],
        states: [],
        showTax: false
    },
    'vi-vn': {
        locale: "vi-vn",
        localeWith_: "vi_VN",
        defaultCurrency: "VND",
        currencySign: "₫",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "VN", countryName: "Vietnam" }
        ],
        states: [],
        showTax: false
    },
    'ko-kr': {
        locale: "ko-kr",
        localeWith_: "ko_KR",
        defaultCurrency: "KRW",
        currencySign: "₩",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            {
                ISO_CC: "KR", countryName: "대한민국(South Korea)"
            }
        ],
        states: [],
        showTax: false
    },
    'zh-tw': {
        locale: "zh-tw",
        localeWith_: "zh_TW",
        defaultCurrency: "TWD",
        currencySign: "NT$",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "TW", countryName: "台灣" }
        ],
        states: [],
        showTax: false
    },
    'es-mx': {
        locale: "es-mx",
        localeWith_: "es_MX",
        defaultCurrency: "MXN",
        currencySign: "MX$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "MX", countryName: "Mexico" }
        ],
        states: mexico,
        showTax: true
    },
    'pt-br': {
        locale: "pt-br",
        localeWith_: "pt_BR",
        defaultCurrency: "BRL",
        currencySign: "R$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "BR", countryName: "Brazil" }
        ],
        states: brazil,
        showTax: true
    },
    'en-hk': {
        locale: "en-hk",
        localeWith_: "en_HK",
        defaultCurrency: "HKD",
        currencySign: "HK$",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: false,
        countyField: true,
        countryList: [
            { ISO_CC: "HK", countryName: "Hong Kong" }
        ],
        states: [],
        showTax: false
    },
    'en-me': {
        locale: "en-me",
        localeWith_: "en_ME",
        defaultCurrency: "USD",
        currencySign: "$",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: false,
        countyField: true,
        countryList: [
            { ISO_CC: "AE", countryName: "United Arab Emirates" }
        ],
        states: uae,
        showTax: false
    },
    'en-ph': {
        locale: "en-ph",
        localeWith_: "en_PH",
        defaultCurrency: "PHP",
        currencySign: "₱",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "PH", countryName: "Philippines" }
        ],
        states: philippines,
        showTax: false
    },
    'nb-no': {
        locale: "nb-no",
        localeWith_: "nb_NO",
        defaultCurrency: "NOK",
        currencySign: "kr",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "NO", countryName: "Norge" }
        ],
        states: [],
        showTax: false
    },
    'pl-pl': {
        locale: "pl-pl",
        localeWith_: "pl_PL",
        defaultCurrency: "PLN",
        currencySign: "zł",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "PL", countryName: "Polska" }
        ],
        states: [],
        showTax: true
    },
    'sv-se': {
        locale: "sv-se",
        localeWith_: "sv_SE",
        defaultCurrency: "SEK",
        currencySign: "kr",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "SE", countryName: "Sverige" }
        ],
        states: [],
        showTax: true
    },
    'da-dk': {
        locale: "da-dk",
        localeWith_: "da_DK",
        defaultCurrency: "DKK",
        currencySign: "kr",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "DK", countryName: "Danmark" }
        ],
        states: [],
        showTax: true
    },
    'fi-fi': {
        locale: "fi-fi",
        localeWith_: "fi_FI",
        defaultCurrency: "EUR",
        currencySign: "€",
        stateDropdown: false,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "FI", countryName: "Suomi" }
        ],
        states: [],
        showTax: true
    },
    'en-ap': {
        locale: "en-ap",
        localeWith_: "en_AP",
        defaultCurrency: "USD",
        currencySign: "$",
        stateDropdown: false,
        countryDropdown: false,
        postalCodeRequired: true,
        countyField: false,
        countryList: [
            { ISO_CC: "AP", countryName: "" }
        ],
        states: [],
        showTax: true
    },
    'en-in': {
        locale: "en-in",
        localeWith_: "en_IN",
        defaultCurrency: "INR",
        currencySign: "₹",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "IN", countryName: "India" }
        ],
        states: india,
        showTax: true
    },
    'en-il': {
        locale: "en-il",
        localeWith_: "en_IL",
        defaultCurrency: "ILS",
        currencySign: "₪",
        stateDropdown: true,
        countryDropdown: true,
        postalCodeRequired: true,
        countyField: true,
        countryList: [
            { ISO_CC: "IL", countryName: "Israel" }
        ],
        states: israel,
        showTax: true
    }
});

// Function to get states based on country code for en-af and es-la locales
export const getStatesForCountry = (countryCode: string) => {
    switch (countryCode) {
        case 'MA':
            return morocco;
        case 'TN':
            return tunisia;
        case 'CR':
            return costaRica;
        case 'DO':
            return dominicanRepublic;
        case 'GT':
            return guatemala;
        case 'PA':
            return panama;
        case 'PR':
            return puertoRico;
        default:
            return [];
    }
};

const urlLocale = window.location.pathname.split('/')[1] as LocaleKey;
export const getLocalizationForLocale = (
    locale: string
): LocalizationContextType =>
    Localization[locale as LocaleKey] || Localization['en-us'];

export const configuredLocales = Object.keys(Localization);

const LocalizationContext = createContext<LocalizationContextType>(getLocalizationForLocale(urlLocale));

export const useLocalization = () => {
    return React.useContext(LocalizationContext);
};

const LocalizationProvider = ({ children }: LocalizationProviderProps) => {
    const [localization, setLocalization] = useState(getLocalizationForLocale(urlLocale)); // Default language

    useEffect(() => {
        setLocalization(getLocalizationForLocale(urlLocale));
    }, []);

    return (
        <LocalizationContext.Provider value={localization}>
            {children}
        </LocalizationContext.Provider>
    );
};

export default LocalizationProvider;